const initialState = () => ({
    collect_removal: {
    },
  });
  
  const state = initialState();
  
  const getters = {
    GET_VAL: (state) => state.collect_removal,
  };
  const mutations = {
    SET_IS_EDIT(state, data) {
      state.isEdit = data;
    },
    SET_ALL_ELEMENT(state, data) {
      state.collect_removal = Object.assign({}, data);
    },
    MERGE_ALL_ELEMENT(state, data) {
      let object1 = state.collect_removal;
      state.collect_removal = Object.assign(object1, data);
    },
    SET_ELEMENT(state, data) {
      state.collect_removal[data.key] = data.value;
    },
    RESET(state) {
      const newState = initialState();
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key];
      });
    },
  };
  
  const actions = {
    W_reset({ commit }) {
      commit("RESET");
    },
    reset({ commit }) {
      commit("RESET");
    },
  };
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  